(function () {
  'use strict';

  /* ══════════════════════════════════════
     GALLERY — arrow nav + thumbnail sync
  ══════════════════════════════════════ */
  function initGallery() {
    document.querySelectorAll('.spap-gallery').forEach(function (gallery) {
      var slides = Array.from(gallery.querySelectorAll('.spap-gallery__slide'));
      var thumbs = Array.from(gallery.querySelectorAll('.spap-gallery__thumb'));
      var dots   = Array.from(gallery.querySelectorAll('.spap-gallery__dot'));
      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');
      var current = 0;

      if (!slides.length) return;

      function goTo(index) {
        var total = slides.length;
        index = ((index % total) + total) % total;
        slides[current].classList.remove('is-active');
        if (thumbs[current]) thumbs[current].classList.remove('is-active');
        if (dots[current])   dots[current].classList.remove('is-active');
        current = index;
        slides[current].classList.add('is-active');
        if (thumbs[current]) thumbs[current].classList.add('is-active');
        if (dots[current])   dots[current].classList.add('is-active');
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { goTo(parseInt(thumb.dataset.thumb, 10)); });
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.dot, 10)); });
      });

      /* Touch swipe */
      var startX = 0;
      var track = gallery.querySelector('.spap-gallery__main');
      if (track) {
        track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        track.addEventListener('touchend', function (e) {
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) diff > 0 ? goTo(current + 1) : goTo(current - 1);
        });
      }

      /* Expose for variant image switching */
      gallery._goTo = goTo;
      gallery._slides = slides;
    });
  }

  /* ══════════════════════════════════════
     VARIANTS — pill selection + price update
  ══════════════════════════════════════ */
  function initVariants() {
    document.querySelectorAll('.spap-variants').forEach(function (variantsEl) {
      var sectionId = variantsEl.id.replace('spap-variants-', '');
      var jsonEl = document.getElementById('spap-variants-json-' + sectionId);
      if (!jsonEl) return;

      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var pills = variantsEl.querySelectorAll('.spap-variant-pill');
      var hiddenInput = document.getElementById('spap-variant-id-' + sectionId);
      var addBtn = document.getElementById('spap-add-to-cart-' + sectionId);
      var priceEl = document.getElementById('spap-price-current');
      var compareEl = document.getElementById('spap-price-compare');

      /* Track current selected options */
      var selectedOptions = {};
      variantsEl.querySelectorAll('[data-option-position]').forEach(function (group) {
        var pos = group.dataset.optionPosition;
        var activePill = group.querySelector('.spap-variant-pill.is-active');
        if (activePill) selectedOptions[pos] = activePill.dataset.optionValue;
      });

      function findVariant() {
        return variants.find(function (v) {
          var o1 = selectedOptions['1'], o2 = selectedOptions['2'], o3 = selectedOptions['3'];
          var match = true;
          if (o1 !== undefined && v.option1 !== o1) match = false;
          if (o2 !== undefined && v.option2 !== o2) match = false;
          if (o3 !== undefined && v.option3 !== o3) match = false;
          return match;
        });
      }

      function updateUI(variant) {
        if (!variant) return;

        /* Update hidden input */
        if (hiddenInput) hiddenInput.value = variant.id;

        /* Update add to cart button */
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.innerHTML = variant.available
            ? '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 2H3.5L5.5 12H13.5L15.5 5H5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7" cy="15" r="1" fill="currentColor"/><circle cx="12" cy="15" r="1" fill="currentColor"/></svg> Add to Cart'
            : 'Sold Out';
        }

        /* Update price */
        var price = (variant.price / 100).toLocaleString('en-ZA', { style: 'currency', currency: 'ZAR', minimumFractionDigits: 2 });
        price = price.replace('ZAR', 'R').replace('ZAR ', 'R ').trim();
        if (priceEl) priceEl.textContent = 'R ' + (variant.price / 100).toFixed(2);
        if (compareEl && variant.compare_at_price > variant.price) {
          compareEl.textContent = 'R ' + (variant.compare_at_price / 100).toFixed(2);
          compareEl.style.display = '';
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }

        /* Update gallery if variant has image */
        if (variant.featured_image) {
          var gallery = document.querySelector('.spap-gallery');
          if (gallery && gallery._goTo && gallery._slides) {
            var imgSrc = variant.featured_image.src.split('?')[0];
            var idx = gallery._slides.findIndex(function (slide) {
              var img = slide.querySelector('img');
              return img && img.src.includes(imgSrc.split('/').pop().split('.')[0]);
            });
            if (idx >= 0) gallery._goTo(idx);
          }
        }

        /* Update buy now URL */
        var buyNow = document.getElementById('spap-buy-now-' + sectionId);
        if (buyNow) buyNow.setAttribute('onclick', "window.location='/cart/" + variant.id + ":1'");
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var pos = pill.dataset.optionPosition;
          var val = pill.dataset.optionValue;

          /* Update active pill in this option group */
          variantsEl.querySelectorAll('[data-option-position="' + pos + '"]').forEach(function (p) {
            p.classList.remove('is-active');
          });
          pill.classList.add('is-active');

          /* Update selected label */
          var label = variantsEl.querySelector('[data-option-selected="' + pos + '"]');
          if (label) label.textContent = val;

          /* Update options map */
          selectedOptions[pos] = val;

          /* Find and apply matching variant */
          var matched = findVariant();
          if (matched) updateUI(matched);
        });
      });
    });
  }

  /* ══════════════════════════════════════
     QUANTITY STEPPER
  ══════════════════════════════════════ */
  function initQty() {
    document.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('.spap-qty').querySelector('input');
        var v = parseInt(input.value, 10);
        if (v > 1) input.value = v - 1;
      });
    });
    document.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('.spap-qty').querySelector('input');
        input.value = parseInt(input.value, 10) + 1;
      });
    });
  }

  /* ══════════════════════════════════════
     DESCRIPTION TABS
  ══════════════════════════════════════ */
  function initTabs() {
    var tabs   = document.querySelectorAll('.spap-desc-tab');
    var panels = document.querySelectorAll('.spap-desc-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('active'); });
        panels.forEach(function (p) { p.classList.remove('active'); });
        tab.classList.add('active');
        var panel = document.querySelector('[data-tab-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* ══════════════════════════════════════
     STICKY BAR — hide when ATC visible
  ══════════════════════════════════════ */
  function initStickyBar() {
    var bar    = document.querySelector('.spap-sticky-bar');
    var atcBtn = document.querySelector('.spap-btn-cart');
    if (!bar || !atcBtn) return;
    bar.style.transition = 'transform 0.3s ease';
    bar.style.transform  = 'translateY(100%)';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.style.transform = e.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
      });
    }, { threshold: 0.5 });
    io.observe(atcBtn);
  }

  /* ══════════════════════════════════════
     INIT
  ══════════════════════════════════════ */
  function init() {
    initGallery();
    initVariants();
    initQty();
    initTabs();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
